import axios from "../../axios/axios-root";

export const notificarCovid = ({ commit }, payload) => {

    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    return axios
    .post("covid19/censo/notificacao/server/controller/notificar.php?opcao=inserir", payload)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })
        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })
    })
    .catch(error => {
        console.error(error)
        commit("sessao/setLoading", false, { root: true })
    });
};


export const alterarCovid = ({ commit }, payload) => {

    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    return axios
    .post("covid19/censo/notificacao/server/controller/notificar.php?opcao=alterar", payload)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })
        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })
    })
    .catch(error => {
        console.error(error)
        commit("sessao/setLoading", false, { root: true })
    });
};